<template>
  <div class="title-bar">
    <button class="icon-button" :class="{disabled: !enableIconButton}" :disabled="!enableIconButton" @click="clickIconButton()" v-if="showIconButton">
      <img :src="iconPath" :srcset="iconSetPath" :class="{back: icon === 'back'}">
    </button>
    <div class="text" :class="{'no-icon': !showIconButton}">
      <div class="primary">{{ text }}</div>
      <div class="secondary">{{ secondaryText }}</div>
    </div>
    <button class="close-button" @click="clickCloseButton()" v-if="showCloseButton">
      <img :src="util.getImagePath('x_white@2x.png')" :srcset="util.getImageSet('x_white')">
    </button>
  </div>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    icon: {
      type: String,
      default: 'promptpai'
    },
    text: {
      type: String,
      default: ''
    },
    secondaryText: {
      type: String,
      default: ''
    },
    showIconButton: {
      type: Boolean,
      default: true
    },
    enableIconButton: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconPath () {
      var self = this
      switch (self.icon) {
        case 'promptpai':
          return self.util.getImagePath('promptpai_icon@2x.png')
        case 'back':
          return self.util.getImagePath(`back_white`)
        case 'pin':
          return self.util.getImagePath('pin_white@2x.png')
      }
    },
    iconSetPath () {
      var self = this
      switch (self.icon) {
        case 'promptpai':
          return self.util.getImageSet('promptpai_icon')
        case 'back':
          return self.util.getImageSet(`back_white`)
        case 'pin':
          return self.util.getImageSet('pin_white')
      }
    }
  },
  methods: {
    clickIconButton () {
      var self = this
      self.$emit('clickIconButton')
    },
    clickCloseButton () {
      var self = this
      self.$emit('clickCloseButton')
    }
  }
}
</script>

<style scoped>
  .title-bar {
    height: 50px;
    width: 100%;
    background: rgb(34, 84, 156);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  button.icon-button,
  button.close-button {
    border: none;
    background-color: transparent;
    height: 50px;
    width: 50px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
  }

  button.icon-button.disabled {
    cursor: unset;
  }

  button.icon-button > img {
    height: 24px;
    width: 24px;
  }

  button.close-button > img {
    height: 16px;
    width: 16px;
  }

  button.icon-button > img.back {
    height: 16px;
    width: 16px;
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    flex: 1;
    width: calc(100% - 50px - 50px);
    padding-right: 16px;
  }

  .text.no-icon {
    padding-left: 16px;
  }

  .text > div {
    color: rgb(255, 255, 255);
    text-align: left;
  }

  .text > .primary {
    font-size: 18px;
    font-family: Prompt;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text > .secondary {
    font-size: 14px;
    line-height: 14px;
    height: fit-content;
    opacity: 0.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/TitleBar.vue